/* prettier-ignore */

import { Component, OnInit, Input } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { RestService } from 'src/app/services/rest.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { DebugService } from 'src/app/services/debug.service';

@Component({
  selector: 'cicerone-pdf-viewer',
  templateUrl: './pdf-viewer.page.html',
  styleUrls: ['./pdf-viewer.page.scss'],
})

export class PDFViewerComponent implements OnInit {  
  @Input("pdf") pdf;
  @Input("name") name;
  @Input("id") id;
  loading: any;
  zoom: number = 100;

  constructor(
    public modalCtrl: ModalController, 
    public sanitizer: DomSanitizer, 
    public loadingController: LoadingController, 
    public translate: TranslateService, 
    public tools: ToolsService,
    private rest: RestService,
    private stats: StatisticsService,
    private debugService: DebugService
  ) { 
      this.tools.setCorporiveColors();
  }

  async ngOnInit(): Promise<void> {
    this.presentLoading(this.translate.instant('Cargando...'));
  }

  async presentLoading(msg: any) {
    this.loading = await this.loadingController.create({
      message: msg,
      showBackdrop: true,
      backdropDismiss: true,
    });
    await this.loading.present();
  }

  dismissModal(){
    this.modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
  }

  dismissAlertLoading() {
    try {
      this.loading.dismiss()
    }catch (error) { 
      this.debugService.error('Error closing dialog', '[PdfViewerPage]') 
    }
  }

  onPdfLoaded(){
    this.dismissAlertLoading();
    if(!this.id)
      return;
    
    this.stats.addPdf(this.id);
    this.rest.increaseVisitsPdf(this.id).subscribe( (response) => {
      const pdf = this.rest.ciceroneData?.pdfs?.find(e => e.id == this.id);
      if (!pdf) 
        return;

      pdf.num_clicks++;
    });
  }

  zoomPDF(zoom){
    switch(zoom){
      case '+': this.zoom = this.zoom + 25; break;
      case '-': this.zoom = this.zoom - 25; break;
      default: break;
    }
  }
}